module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMzMTMxMzA7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkdMRTEyNDg3X1dlYnNpdGVfSWNvbnM8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjUiIGN5PSIyNSIgcj0iMTgiLz48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjMyLjk4OCAyMS4wMDYgMjUgMjguOTk0IDE3LjAxMiAyMS4wMDYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/svg/down-circle.svg
// module id = 199
// module chunks = 54990529738226 137591856104208